
import { LOGIN_PROVIDER } from "@toruslabs/base-controllers";
import Vue from "vue";

export default Vue.extend({
  name: "LoginScreen",
  props: {
    setStep: {
      type: Function,
    },
    connect: {
      type: Function,
    },
    submitting: { type: Boolean, default: false },
  },
  data: () => ({
    validForm: true,
    email: "",
    rules: {
      required: (value: string) => !!value || "Required.",
      email: (value: string): string | boolean =>
        /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/.test(value) ||
        "Invalid email",
    },
  }),
  methods: {
    async connectTo(loginProvider: string, loginHint?: string) {
      await this.connect(loginProvider, loginHint);
    },
    connnectWithEmail() {
      this.connectTo(LOGIN_PROVIDER.EMAIL_PASSWORDLESS, this.email);
    },
  },
});
